/// <reference types="@types/google.maps" />
import { Component, OnInit, Input, SimpleChanges, OnChanges, Injector, ViewChild, OnDestroy, AfterViewInit,
	ViewChildren, QueryList, Output, EventEmitter, ElementRef, ComponentRef, TemplateRef, ViewContainerRef, ContentChildren, Renderer2 } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of, Subject, Subscription } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BeachSite, isBeachSite } from '../../models/BeachSite';
import { BeachsitesListService } from '../beachsites-list-service';
import { SiteMarkerClickEvent, SiteMarkerComponent } from '../site-marker/site-marker.component';
import { GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';

import { SitesService } from 'src/app/services/sites.service';
import { SitePopupInfoModel } from 'src/app/models/SiteDetails/SitePopupInfoModel';
import { SiteWeatherForecastModel } from 'src/app/models/SiteDetails/SiteWeatherForecastModel';
import { environment } from '../../../environments/environment';
import { GridAlgorithm, MarkerClusterer, SuperClusterAlgorithm } from '@googlemaps/markerclusterer';
import { Cluster } from '@googlemaps/markerclusterer/dist/cluster';
import { ClusterStats } from '@googlemaps/markerclusterer/dist/renderer';
import { MAP_BOUNDS_CHANGED_INTERVAL, NSWMapBounds } from '../../models/app-constants';
import { ZoomToSearchResultService } from 'src/app/beach-watch-map/ZoomToSearchResultService';
import { isPOI, POI } from 'src/app/models/POI';
import { Address, isAddress } from 'src/app/models/Address';
import { getBeachSitesInArea, isRegion, Region } from 'src/app/models/SiteGroups';
import { isSuburb, Suburb } from 'src/app/models/Suburb';
import { GoogleMapsApiLoaderService } from 'src/app/GoogleMapsApiLoaderService';
import { isNull, isUndefined } from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { ListService } from 'src/app/services/list.service';
import { AppMonitoringService } from 'src/app/services/logging.service';


declare var google: any;

export interface MapBoundsChangedEvent 
{ 
	bounds : any ; 
	zoomToCurrentLocation : boolean;
} 

@Component({
	selector: 'app-beach-watch-google-map',
	templateUrl: './beach-watch-google-map.component.html',
	styleUrls: ['./beach-watch-google-map.component.scss'],
	providers: [SitesService]
})

export class BeachWatchGoogleMapComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {

	apiLoaded$ : Observable<boolean>;
	
	private lat = -32.8310356; // -29.103812466142127;
	private lng = 147.3190045; // 153.42214282322382;	
	
	private siteMapMarkers: { siteId: string; mapMarker: MapMarker, markerElementRef : ElementRef | null | undefined }[];
	private markerClusterer: MarkerClusterer;

	sitePopupInfo: SitePopupInfoModel;	

	googleMapRef: GoogleMap | undefined;
	mapSubject: Subject<google.maps.Map> = new Subject<google.maps.Map>();
	private mapSubjectSub$ : Subscription;
	showSearchPopUp = { show: false, siteId: "" };
	infoWindowPixelOffsetSize : any;
	@Input() popupClosedEvent : Observable<void>;
	private popupClosedSub : Subscription;
	private siteIdentifierSub : Subscription;
	private allBeachesLoadSub : Subscription;
	/*
		ViewChild will be null in ngAfterViewInit because of *ngIf="apiLoaded | async" used in the component template.
		Options :
		1. Use static : false, the @ViewChild reference gets updated by Angular when the *ngIf directive changes.
		2. Move ngIf to the parent component.
		3. Use ViewChildren to grab the components or setTimeout (ugly).
	*/
	@ViewChild("mapComponent", { static: false }) mapComponent : GoogleMap;
	@ViewChild(MapInfoWindow) infoWindow: MapInfoWindow;	

	@ViewChild(MapInfoWindow, { read : ElementRef }) infoWindowElementRef : ElementRef;		
	@ViewChild("element", { read : ElementRef }) elementRef : ElementRef;	
	//@Input() beachSitesListElementRef : ElementRef;

	@ViewChildren(GoogleMap) mapComponents: QueryList<GoogleMap>;	
	private mapCompChangesSub : Subscription;
	@ViewChildren(SiteMarkerComponent) siteMarkerComponents: QueryList<SiteMarkerComponent>;
	
	private allRegions : BehaviorSubject<Region[]> = new BehaviorSubject<Region[]>([]);
	private regionsSubscription : Subscription;

	private ZOOM_TO_CURRENT_LOCATION : boolean = false;
	private markerCompsChangesSub : Subscription;
	private googleMapsApiServiceSub : Subscription;
	private mapOverlay : google.maps.OverlayView;	
	private ZOOM_TO_LOCATION_ZOOMLEVEL = 15;
	private overlayProjection : google.maps.MapCanvasProjection;

	
	infoWindowVisible : boolean = false;
	
	@Output() mapBoundsChangedEvent: EventEmitter<MapBoundsChangedEvent> = new EventEmitter<MapBoundsChangedEvent>();
	@Output() mapIdle: EventEmitter<google.maps.LatLngBounds | undefined> = new EventEmitter<google.maps.LatLngBounds | undefined>();
	@Output() showPopup : EventEmitter<any> = new EventEmitter<any>();	
	@Output() closePopup  : EventEmitter<any> = new EventEmitter<any>();

	private selectedBeachSiteIdentifier : string = "";

	private geoLocationOptions = {
		enableHighAccuracy: true,
		timeout: 5000,
		maximumAge: 0,
	};

	infoWindowPosition : google.maps.LatLng | undefined | null;
		

	private boundsChangedTimeout: any;

	private customMapStyle: any = [
		{
		  "featureType": "administrative.land_parcel",
		  "elementType": "labels",
		  "stylers": [
			{
			  "visibility": "off"
			}
		  ]
		},
		{
		  "featureType": "administrative.land_parcel",
		  "elementType": "labels.text",
		  "stylers": [
			{
			  "visibility": "off"
			}
		  ]
		},
		{
		  "featureType": "administrative.neighborhood",
		  "stylers": [
			{
			  "visibility": "off"
			}
		  ]
		},
		{
		  "featureType": "landscape.man_made",
		  "elementType": "geometry.fill",
		  "stylers": [
			{
			  "color": "#e3e3e3"
			}
		  ]
		},
		{
		  "featureType": "landscape.man_made",
		  "elementType": "labels.text",
		  "stylers": [
			{
			  "visibility": "off"
			}
		  ]
		},
		{
		  "featureType": "landscape.natural",
		  "elementType": "geometry.fill",
		  "stylers": [
			{
			  "color": "#dbeccc"
			}
		  ]
		},
		{
		  "featureType": "poi",
		  "stylers": [
			{
			  "visibility": "off"
			}
		  ]
		},
		{
		  "featureType": "poi",
		  "elementType": "labels.text",
		  "stylers": [
			{
			  "visibility": "off"
			}
		  ]
		},
		{
		  "featureType": "poi.attraction",
		  "stylers": [
			{
			  "visibility": "off"
			}
		  ]
		},
		{
		  "featureType": "poi.business",
		  "stylers": [
			{
			  "visibility": "off"
			}
		  ]
		},
		{
		  "featureType": "poi.government",
		  "stylers": [
			{
			  "visibility": "off"
			}
		  ]
		},
		{
		  "featureType": "poi.medical",
		  "stylers": [
			{
			  "visibility": "off"
			}
		  ]
		},
		{
		  "featureType": "road",
		  "elementType": "labels.icon",
		  "stylers": [
			{
			  "visibility": "off"
			}
		  ]
		},
		{
		  "featureType": "road.highway",
		  "elementType": "geometry.fill",
		  "stylers": [
			{
			  "color": "#c9c9c9"
			}
		  ]
		},
		{
		  "featureType": "road.highway",
		  "elementType": "geometry.stroke",
		  "stylers": [
			{
			  "visibility": "off"
			}
		  ]
		},
		{
		  "featureType": "road.local",
		  "elementType": "labels",
		  "stylers": [
			{
			  "visibility": "off"
			}
		  ]
		},
		{
		  "featureType": "transit",
		  "stylers": [
			{
			  "visibility": "off"
			}
		  ]
		},
		{
		  "featureType": "water",
		  "elementType": "geometry.fill",
		  "stylers": [
			{
			  "color": "#d1f1ff"
			}
		  ]
		}
	  ];

	/* 
		Sites are fetched from the api and is an observable in maps section component,
		The following are the ways to create markers when the sites is changed
		1. using ngOnChanges : see use of Input sites and ngOnChanges lifecycle method and use ng-container with ngIf condition that sites is not empty in the map component to add markers
		2. Pass observable as input and subscribe to the observable property in ngOnInit (set the beachSites array as BehaviorObject) and in the maps section component html pass beachSites.asObservable() to the sites property of map component
		3. Use a service to communicate between 2 or more components and subscribe to the observable in the service.
		4. Using BehaviorSubject along with getter (decorate with @Input()) and setter
	*/

	/* Approach 1 */
	//@Input() sites$: BeachSite[];

	/* Approach 2 : */
	//@Input() observableSites$: Observable<BeachSite[]>;

	/* Approach 3 : Use a srevice to communicate between components */
	//beachSitesList: BeachSite[] = [];

	/* Approach 4 : getter and setter */
	private _beachsites: BehaviorSubject<BeachSite[]> = new BehaviorSubject<BeachSite[]>([]);
	@Input()
	get beachSites() {
		return this._beachsites.getValue();
	}

	set beachSites(value) {
		this._beachsites.next(value);
	}

	private _allBeachSites$ : BehaviorSubject<BeachSite[]> = new BehaviorSubject<BeachSite[]>([]);
	

	@Input() 
	get allBeachSites() {
		return this._allBeachSites$.getValue();
	}
	set allBeachSites(value) {
		this._allBeachSites$.next(value);
	}

	private siteLinkClickedEventSubscription : Subscription;
	@Input() siteLinkClickedEvent : Observable<BeachSite>;


	private zoomToSearchSubscription: Subscription;	

	options : any;
	parent : any
	
	constructor(private httpClient: HttpClient,
		private googleMapsApiLoaderService : GoogleMapsApiLoaderService,
		private sitesService: SitesService,
		private zoomToSearchService: ZoomToSearchResultService,
		private activatedRoute : ActivatedRoute, 
		private router : Router,
		private listService : ListService,
		private appMonitoringService: AppMonitoringService
	) 
	{		
		this.subscribeToGoogleMapApiLoaded();		
	}	

	ngOnInit(): void {	

		/* Approach 3 : Use a srevice to communicate between components */
		// this.beachsitesListService.beachSitesList$.subscribe((value) => {
		// 	this.beachSitesList = value;
		// });
		// const myLatLng = { lat: -29.103400000, lng: 153.433123456 };
		// const marker = new google.maps.Marker({
		// 	position: myLatLng,
		// 	this.googleMapRef?.googleMap			
		//   });

		// this.infoWindow.open(marker.getAnchor(), true);
		this.getAllRegions();

		this.subscribeToSiteLinkClick();

		this.subscribeToGoogleMapRefChanged();

		this.initSearch();
		

		this.siteIdentifierSub = this.activatedRoute.queryParams.subscribe({
			next : (params : any) => 
			{				
				this.selectedBeachSiteIdentifier = params.siteIdentifier ?? "";	
				if(!this.selectedBeachSiteIdentifier)
				{
					return;
				}
				this.zoomToSelectedSite();		
			},
			error : (ex : Error) => {

			},
			complete : () => {

		}});
		

		this.allBeachesLoadSub = this._allBeachSites$.subscribe({
			next : (data) => {
				if(this.selectedBeachSiteIdentifier)
				{
					this.zoomToSelectedSite();			
				}
			},
			error : (ex : Error) => {

			},
			complete : () => {

			}
		});

		this.popupClosedSub = this.popupClosedEvent?.subscribe({
			next : (data) => {
				if(this.selectedBeachSiteIdentifier)
				{
					this.clearSiteIdentifierAndQueryParam();
				}				
			}
		})
	}

	private clearSiteIdentifierAndQueryParam = () => {
		// clear the selected identifier to prevent map from zooming to selected site and displaying pop-up information
		this.selectedBeachSiteIdentifier = "";
		// clear the query parameter from the route
		this.router.navigate(['.'], { relativeTo: this.activatedRoute });
	}

	private getAllRegions() {
		this.regionsSubscription = this.listService.getRegionList().subscribe({
			next : (regions) => {				
				
				if(Array.isArray(regions))	
				{					
					this.allRegions.next(regions);					
				}
			},
			error : (error) => {
				
			},
			complete : () => {				
			}
		});	
	}

	private scrollMapIntoView = () => {
		
		const mapViewSection = document.querySelector("#tabContent");
		const mapViewSectionRect = mapViewSection?.getBoundingClientRect();
		const windowBottom = window.screenTop + window.innerHeight;				

		if(mapViewSection && mapViewSectionRect)
		{				
			const isInViewport = mapViewSectionRect?.top >= 0 &&
				mapViewSectionRect?.left >= 0 &&
				mapViewSectionRect?.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
				mapViewSectionRect?.right <= (window.innerWidth || document.documentElement.clientWidth);
			if(!isInViewport)
			{
				const scrollX = 0;
				const scrollY = document.documentElement.clientTop - mapViewSectionRect.top + 
					(document.documentElement.clientHeight - mapViewSection?.clientHeight) / 2
				window.scrollBy({ top : -scrollY, left : 0, behavior : 'smooth' });						
			}
		}
		
	}
	private zoomToSelectedSite = () => {
		if(!this.selectedBeachSiteIdentifier)
		{
			return;			
		}
		const beachSite = this.allBeachSites?.find((site : BeachSite) => site.Identifier === this.selectedBeachSiteIdentifier);
		if (beachSite?.Identifier) 
		{				
			//this.centerMapOnSiteToDisplayPopup(beachSite, null, this.ZOOM_TO_LOCATION_ZOOMLEVEL);
			this.clearSiteIdentifierAndQueryParam();
			// use a timer instead of watching for route navigation end on clearing the query parameter from the route.
			setTimeout(() => {
				this.scrollMapIntoView();
				//this.zoomToPoint(new google.maps.LatLng(beachSite.Lat, beachSite.Lng), 18);
				this.centerMapOnSiteToDisplayPopup(beachSite, null, 18);				
			}, 10);			
		}		
	}

	ngOnChanges(changes: SimpleChanges) {

	}	

	ngAfterViewInit(): void 
	{
		this.subscribeToMapCompsChanges();			
	}

	ngOnDestroy() {
		this.siteLinkClickedEventSubscription?.unsubscribe();
		this.zoomToSearchSubscription?.unsubscribe();
		this.mapCompChangesSub && this.mapCompChangesSub.unsubscribe();
		this.mapSubjectSub$ && this.mapSubjectSub$.unsubscribe();
		this.markerCompsChangesSub && this.markerCompsChangesSub.unsubscribe();
		this.googleMapsApiServiceSub && this.googleMapsApiServiceSub.unsubscribe();
		this.popupClosedSub && this.popupClosedSub?.unsubscribe();
		this.allBeachesLoadSub && this.allBeachesLoadSub?.unsubscribe();
		this.siteIdentifierSub && this.siteIdentifierSub?.unsubscribe();
		this.googleMapsApiServiceSub && this.googleMapsApiServiceSub.unsubscribe();
		this.mapSubjectSub$ && this.mapSubjectSub$.unsubscribe();
		this.markerCompsChangesSub && this.markerCompsChangesSub.unsubscribe();
		this.regionsSubscription && this.regionsSubscription?.unsubscribe();
	}

	private subscribeToGoogleMapApiLoaded = () => {
		this.googleMapsApiServiceSub = this.googleMapsApiLoaderService.googleMapsApiLoaded$.subscribe({
			next : (result : boolean) => {	
				if(result)
				{
					this.apiLoaded$ = of(true);
					this.initGoogleMapOptions();					
				}		
								
			},
			error : (ex : any) => {
				this.apiLoaded$ = of(false);
				console.debug(`[Exception setting google maps options : ${ex.message}]`);
			},
			complete : () => {
				
			}
		});
	}
	

	private initGoogleMapOptions = () => {
		if(google?.maps?.Map)
		{			
			try
			{
				this.options = google.maps.MapOptions = {
					center: { lat: this.lat, lng: this.lng },
					styles: this.customMapStyle,
					//scrollwheel: true,
					//gestureHandling : "cooperative",		
					zoom: 10, 
					//maxZoom : 18,
					mapTypeControl: false,
					fullscreenControl: false,
					isFractionalZoomEnabled : false,
					rotateControl : false,
					scaleControl: true,
					streetViewControl : false,								
					// restriction: {
					// 	latLngBounds: {
					// 		// extents of Australia
					// 		north: -3.468265,
					// 		south: -43.456167,
					// 		west: 101.702615,
					// 		east: 157.414743
					// 	},
					// 	strictBounds: false,
					// },
					mapTypeControlOptions: {
						style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
						position: google.maps.ControlPosition.TOP_RIGHT,
					}
				};
				
				this.infoWindowPixelOffsetSize = new google.maps.Size(0, -10);
				
			}
			catch(ex : any) {
				console.debug(`[Exception setting google maps options : ${ex.message}]`);
			}			
		}
	}

	private subscribeToGoogleMapRefChanged = () => {
		this.mapSubjectSub$ = this.mapSubject.subscribe({
			next : (result) => {
				this.onGoogleMapRefInitialized(result);
			},
			error : (ex) => {

			},
			complete : () => {
				
			}
		});
	}	

	private subscribeToSiteLinkClick = () => {
		this.siteLinkClickedEventSubscription = this.siteLinkClickedEvent.subscribe((site) => {	
			//this.closePopup.emit();
			this.centerMapOnSiteToDisplayPopup(site, document.activeElement, this.ZOOM_TO_LOCATION_ZOOMLEVEL, );			
		});
	}

	private subscribeToMapCompsChanges = () => {
		this.googleMapRef = this.mapComponent;

		if(!this.googleMapRef)
		{
			this.mapCompChangesSub = this.mapComponents.changes.subscribe({
				next :  (comps: QueryList<GoogleMap>) => {
					this.googleMapRef = comps.first;
					if (this.googleMapRef?.googleMap) 
					{
						this.mapSubject.next(this.googleMapRef.googleMap);						
					}	
					
					this.mapOverlay = new google.maps.OverlayView();
					this.mapOverlay.draw = function() {};

					this.mapOverlay.onAdd = () => {
						this.overlayProjection = this.mapOverlay.getProjection();						
					};
					this.mapOverlay.setMap(this.googleMapRef.googleMap!);					
				},
				error : (ex) => {

				},
				complete : () => {
					this.mapCompChangesSub && this.mapCompChangesSub.unsubscribe();
				}
			});
		}
		else
		{			
			this.mapSubject.next(this.googleMapRef.googleMap!);			
		}	
	}


	private onGoogleMapRefInitialized = (mapRefCurrentValue : any) => {
		if(mapRefCurrentValue)
		{
			this.ZOOM_TO_CURRENT_LOCATION = true;
			this.zoomToCurrentCurrentLocation();
			this.subscribeToMarkerCompsChanges();
		}			
	}

	private subscribeToMarkerCompsChanges = () => {
		this.markerCompsChangesSub = this.siteMarkerComponents.changes.subscribe({
			next : (comps : QueryList<SiteMarkerComponent>) => {				
				this.siteMapMarkers = [];
				comps.forEach((element : any) => {
					// get the MapMarker from the site marker
					const siteMarker = element.siteMapMarker;
					if (siteMarker && undefined != siteMarker.mapMarker) 
					{
						this.siteMapMarkers.push(siteMarker);
					}
				});

				if (this.googleMapRef) 
				{
					/*
					if (this.showSearchPopUp.show && this.showSearchPopUp.siteId) 
					{
						//this.displaySearchPopup();
					}
					*/

					this.createMarkerClusterer();
				}			
			},
			error : (ex) => {

			},
			complete : () => {
				
			}
		});		
	}	

	private getRegionExtents = (region : Region) => {
		let extents = null, centre = null;
		let sitesInRegion = region.Sites;
		if(!Array.isArray(sitesInRegion) || 0 === sitesInRegion?.length)
		{
			sitesInRegion = getBeachSitesInArea(this.allBeachSites, this.allRegions.getValue(), region, false);
		}
		
		if(Array.isArray(sitesInRegion) && 0 < sitesInRegion.length)
		{			
			const lats = sitesInRegion.map((site) => Number(site.Lat));
			const lngs = sitesInRegion.map((site) => Number(site.Lng));
			extents  = { 
				north : Math.max(...lats), 
				south : Math.min(...lats),
				west : Math.min(...lngs), 
				east : Math.max(...lngs)
			};
			centre = { x : (extents.west + extents.east) / 2.0, y : (extents.north + extents.south) / 2.0 };
			const width = extents.east - extents.west;
			const height = extents.north - extents.south;
			// Expand the extents
			extents = { 
				north : centre.y + height, 
				south : centre.y - height,
				west : centre.x - width, 
				east : centre.x + width
			};
		}	

		return { extents, centre };
	}

	private initSearch() {

		this.zoomToSearchSubscription = this.zoomToSearchService.zoomToData?.subscribe({
			next: (data: any) => {
				if (null == data)
					return;				

				if("CURRENT_LOCATION" === data)
				{
					this.zoomToCurrentCurrentLocation();
					return;
				}


				const { area, focusElement } = data;
				
				this.infoWindow && "function" === typeof(this.infoWindow.close) && this.infoWindow.close();
				
				
				if (isPOI(area)) 
				{
					const poi = <POI>area;
					poi?.geometry?.x && poi?.geometry?.y &&
						this.zoomToPoint(new google.maps.LatLng(poi.geometry.y, poi.geometry.x), this.ZOOM_TO_LOCATION_ZOOMLEVEL);
				}
				else if (isAddress(area)) 
				{
					const address = <Address>area;
					
					this.sitesService.getAddressLatLng(address.propId).subscribe(response => {
						if (Array.isArray(response) && 0 < response.length) {
							this.zoomToPoint(new google.maps.LatLng(response[0].y, response[0].x), this.ZOOM_TO_LOCATION_ZOOMLEVEL);
						}						
					});
				}
				else if (isBeachSite(area)) 
				{					
					const beachSite = <BeachSite>area;
					if (beachSite.Identifier) 
					{						
						const site = this.allBeachSites.find((site : BeachSite) => site.Identifier === beachSite.Identifier);
						site?.Identifier && this.centerMapOnSiteToDisplayPopup(site, focusElement, this.ZOOM_TO_LOCATION_ZOOMLEVEL);						
					}
				}
				else if (isRegion(area)) 
				{
					const region = <Region>area;
					const regionShape = this.getRegionExtents(region);
					if(null != regionShape.extents && null != regionShape.centre)
					{	
						this.googleMapRef?.googleMap?.fitBounds(regionShape.extents);
						//this.zoomToPoint(new google.maps.LatLng(regionShape.centre.y, regionShape.centre.x), 13);
					}					
				}
				else if (isSuburb(area)) 
				{
					const suburb = <Suburb>area;
					suburb?.geometry?.x && suburb?.geometry?.y &&
						this.zoomToPoint(new google.maps.LatLng(suburb.geometry.y, suburb.geometry.x), this.ZOOM_TO_LOCATION_ZOOMLEVEL);
				}
				
			},
			error: (error: any) => {
				
			},
			complete: () => {
				
			}
		});
	}

	private createMarkerClusterer = () => {
		if (this.googleMapRef?.googleMap) {
			const mcOptions = {
				gridSize: 50,
				minimumClusterSize: 10
			};

			// ! is non-null assertion operator 
			const markersToCluster = this.siteMapMarkers.map((a) => a.mapMarker.marker!).filter(Boolean) || [];

			if (this.markerClusterer) 
			{
				this.markerClusterer.clearMarkers();
				//this.markerClusterer.addMarkers(markersToCluster);				
			}
			//else 
			{
				this.markerClusterer = new MarkerClusterer({
					map: this.googleMapRef.googleMap,
					markers: markersToCluster.filter(Boolean),
					//algorithm : new SuperClusterAlgorithm({maxZoom : 13}),
					algorithm : new GridAlgorithm({																			
						maxZoom : 12
					}),
					renderer: { render: this.clusterRenderer }
				});
			}
		}
	}

	private clusterRenderer = (cluster: Cluster, stats: ClusterStats): google.maps.Marker => {
		const clusterIcon = {
			url: 'assets/images/Map/ClusterIcon.svg',
			scaledSize: new google.maps.Size(32, 32),
		};
		return new google.maps.Marker({
			/*
				https://developers.google.com/maps/documentation/javascript/reference/marker#MarkerLabel
				The font color, size, weight, and family can only be set via the other properties of MarkerLabel.				  
			*/
			label: {
				text: cluster.count.toString(),
				className: "marker-cluster-label",
				fontFamily: "Public Sans",
				fontStyle: "normal",
				fontSize: "16px",
				fontWeight: "700",
				lineHeight: "24px",
				color: "#FFFFFF"
			},
			position: cluster.position,
			icon: clusterIcon,
			zIndex: Number(google.maps.Marker.MAX_ZINDEX) + cluster.count,
		});
	}
	
	private zoomToPoint(latLng: google.maps.LatLng | google.maps.LatLngLiteral, zoomLevel?: number) {
		if (this.googleMapRef && this.googleMapRef.googleMap) {
			this.googleMapRef.googleMap.setCenter(latLng);
			if (zoomLevel) 
			{
				this.googleMapRef.googleMap.setZoom(zoomLevel);
			}			
		}
	}

	private panToBounds = (extents: google.maps.LatLngBounds | google.maps.LatLngBoundsLiteral, zoomLevel?: number) => {
		if (this.googleMapRef && this.googleMapRef.googleMap) 
		{
			this.googleMapRef.googleMap.panToBounds(extents);
			if (zoomLevel) {
				this.googleMapRef.googleMap.setZoom(zoomLevel);
			}
		}
	}

	private zoomToCurrentCurrentLocation(): void {	
		navigator.geolocation.getCurrentPosition((position) => {
			const { latitude, longitude } = position.coords;
			this.zoomToPoint({ lat: latitude, lng: longitude }, 10);
		},
			(error) => {
				const { code } = error;
				switch (code) {
					case GeolocationPositionError.TIMEOUT:
						console.debug("Geo-location : getCurrentPosition timed out");
						break;
					case GeolocationPositionError.PERMISSION_DENIED:
						console.debug("Geo-location : getCurrentPosition : user has denied persmission");
						break;
					case GeolocationPositionError.POSITION_UNAVAILABLE:
						console.debug("Geo-location : getCurrentPosition : position not avialable");
						break;
				}
			}, this.geoLocationOptions);
	}

	private displaySearchPopup() 
	{
		if (this.showSearchPopUp.show && this.showSearchPopUp.siteId) 
		{
			const site = this.allBeachSites.find((site : BeachSite) => site.Identifier === this.showSearchPopUp.siteId);
			const siteMapMarker = this.siteMapMarkers?.find((a) => a.siteId === this.showSearchPopUp.siteId)
			
			if (site && siteMapMarker && null != siteMapMarker.mapMarker) 
			{				
				this.onMapMarkerClicked({
					siteId: this.showSearchPopUp.siteId,
					mapMarker : siteMapMarker.mapMarker,
					marker: siteMapMarker.mapMarker.marker!,
					event : undefined					
				});
				this.showSearchPopUp = { show: false, siteId: "" };
			}
		}
	}	

	public onMapMarkerClicked(event: SiteMarkerClickEvent) {
		if(!event.siteId)
		{
			return;
		}	
		if(event?.mapMarker?.marker)	
		{

			this.appMonitoringService.logEvent('PopupOpenFromMapClick',{'site_identifier': event.siteId})

			this.showPopupWindow(event.siteId, 
				event.mapMarker.marker.getPosition()!, 
				document.activeElement);
				
			//this.openAndPositionInfowWindow(event.siteId,  event.mapMarker?.marker?.getPosition()!);
		}		
	}


	private centerMapOnSiteToDisplayPopup = (site : BeachSite, activeElement : any, zoomLevel = this.ZOOM_TO_LOCATION_ZOOMLEVEL) =>
	{
		this.zoomToPoint(new google.maps.LatLng(site.Lat, site.Lng), zoomLevel);
		this.showSearchPopUp = { show: true, siteId: site.Identifier };
		this.infoWindowPosition = new google.maps.LatLng(site.Lat, site.Lng);
		//this.openAndPositionInfowWindow(site.Identifier,  this.infoWindowPosition!);

		this.showPopupWindow(site.Identifier, this.infoWindowPosition!, activeElement);	
	}

	private openAndPositionInfowWindow = (siteId : string, initialPosition? : google.maps.LatLng) => {
				
		this.sitesService.getSitePopupInfo(siteId).subscribe((data: any) => 
		{
			if(!data?.Identifier)
			{
				return;
			}
			
			try 
			{				
				this.sitePopupInfo = <SitePopupInfoModel>{...data,
					LatestResultDate : null != data.LatestResultDate ? new Date(Date.parse(data.LatestResultDate)) : null,
					PollForecastDateTime : null != data.PollForecastDateTime ? new Date(Date.parse(data.PollForecastDateTime)) : null,
					WeatherForecast : <SiteWeatherForecastModel> {
						...data.WeatherForecast, 
						FirstTideHighTime : null != data?.WeatherForecast?.FirstTideHighTime ? new Date(Date.parse(data?.WeatherForecast?.FirstTideHighTime)) : null,
						FirstTideLowTime : null != data?.WeatherForecast?.FirstTideLowTime ? new Date(Date.parse(data?.WeatherForecast?.FirstTideLowTime)) : null,
						NextTideHighTime : null != data?.WeatherForecast?.NextTideHighTime ? new Date(Date.parse(data?.WeatherForecast?.NextTideHighTime)) : null,
						NextTideLowTime : null != data?.WeatherForecast?.NextTideLowTime ? new Date(Date.parse(data?.WeatherForecast?.NextTideLowTime)) : null,
						SecondTideHighTime : null != data?.WeatherForecast?.SecondTideHighTime ? new Date(Date.parse(data?.WeatherForecast?.SecondTideHighTime)) : null,
						SecondTideLowTime : null != data?.WeatherForecast?.SecondTideLowTime ? new Date(Date.parse(data?.WeatherForecast?.SecondTideLowTime)) : null
					}
				};
				
				/*
				if(this.infoWindow)
				{					
					const sitesListDiv = document.querySelector("#beachSitesList");
					//const sitesListDiv = this.beachSitesListElementRef?.nativeElement;
					const sitesListRect = sitesListDiv?.getBoundingClientRect();
					const mapDiv = this.googleMapRef?.googleMap?.getDiv();
					const mapRect = mapDiv?.getBoundingClientRect();
					
					const infoWindoRect = this.infoWindowElementRef?.nativeElement?.getBoundingClientRect();
					if(mapRect && sitesListRect && infoWindoRect && mapDiv)
					{	
						const listOffsetLeft = sitesListRect.left - mapRect.left;
						const width = (mapRect.width - listOffsetLeft) / 2;
						const leftWidth = listOffsetLeft +  sitesListRect.width;
						const rightWidth = mapRect.width - leftWidth;
						
						let offsetX = sitesListRect.right + (mapRect?.right - sitesListRect.right) / 2;
						offsetX = listOffsetLeft + (rightWidth / 2); //mapRect?.left + leftWidth + (rightWidth / 2);
						offsetX = mapRect.right - rightWidth / 2;
						const offsetY = mapRect?.top + infoWindoRect?.height + (mapRect?.height - infoWindoRect?.height) / 2;		
			
						const positionToPixel = this.fromLatLngToPoint(initialPosition);
						const mapCenter = this.googleMapRef?.googleMap?.getCenter();
			
						const dX = offsetX - positionToPixel.x;
						const dY = offsetY - positionToPixel.y;
						const latLngPosition = this.pixelOffsetToLatLng(offsetX, offsetY);
						this.googleMapRef?.googleMap?.panBy(-dX, -dY);			
						this.infoWindow.position = initialPosition!;
						this.infoWindow.open();							
					}  
				}
				*/
			}
			catch(ex)
			{

			}
		});		  		
	}


	private openInfoWindow = (siteId : string, position : google.maps.LatLng | undefined | null, 
		mapMarker : MapMarker, markerElementRef? : ElementRef | null) => 
	{	
		if(mapMarker && mapMarker?.marker)
		{
			if(mapMarker?.marker)
			{
				this.infoWindowPosition = mapMarker?.marker?.getPosition();
				this.openAndPositionInfowWindow(siteId, mapMarker.marker.getPosition()!)
			}	
		}		
	}	

	showPopupWindow(siteId : string, position : google.maps.LatLng, activeElement : any ) 
	{
		this.infoWindowVisible = true;		
		// this.showPopup.emit({ 
		// 	siteId : siteId,
		// 	position : position, 			
		// 	activeElement : activeElement		
		// });	
		
		if(siteId)
		{	
			this.sitesService.getSitePopupInfo(siteId).subscribe({
				next : (data : any) => {
					if(!data?.Identifier)
					{						
						return;
					}

					const popupInfo  = <SitePopupInfoModel>{...data,
						LatestResultDate : null != data.LatestResultDate ? new Date(Date.parse(data.LatestResultDate)) : null,
						PollForecastDateTime : null != data.PollForecastDateTime ? new Date(Date.parse(data.PollForecastDateTime)) : null,
						WeatherForecast : <SiteWeatherForecastModel>{
							...data.WeatherForecast, 
							FirstTideHighTime : null != data?.WeatherForecast?.FirstTideHighTime ? new Date(Date.parse(data?.WeatherForecast?.FirstTideHighTime)) : null,
							FirstTideLowTime : null != data?.WeatherForecast?.FirstTideLowTime ? new Date(Date.parse(data?.WeatherForecast?.FirstTideLowTime)) : null,
							NextTideHighTime : null != data?.WeatherForecast?.NextTideHighTime ? new Date(Date.parse(data?.WeatherForecast?.NextTideHighTime)) : null,
							NextTideLowTime : null != data?.WeatherForecast?.NextTideLowTime ? new Date(Date.parse(data?.WeatherForecast?.NextTideLowTime)) : null,
							SecondTideHighTime : null != data?.WeatherForecast?.SecondTideHighTime ? new Date(Date.parse(data?.WeatherForecast?.SecondTideHighTime)) : null,
							SecondTideLowTime : null != data?.WeatherForecast?.SecondTideLowTime ? new Date(Date.parse(data?.WeatherForecast?.SecondTideLowTime)) : null
						}
					};
					
					this.showPopup.emit({ 
						siteId : siteId,
						position : position, 		
						popupInfo : popupInfo,	
						activeElement : activeElement	
					});
				},
				error : (ex : Error) => {

				},
				complete : () => {

				}
			});	
		}
	}

	

	public onZoomToCurrentLocationClicked(event: MouseEvent): void {
		this.ZOOM_TO_CURRENT_LOCATION = false;		
		this.zoomToCurrentCurrentLocation();
	}

	public onMapBoundsChanged() {
		//this.mapBoundsChangedEvent.emit(this.googleMapRef?.googleMap?.getBounds());
		
		clearTimeout(this.boundsChangedTimeout);
		this.boundsChangedTimeout = setTimeout(() => {			
			this.mapBoundsChangedEvent.emit({ bounds : this.googleMapRef?.googleMap?.getBounds(), 
				zoomToCurrentLocation : this.ZOOM_TO_CURRENT_LOCATION });
			this.ZOOM_TO_CURRENT_LOCATION = false;
		}, MAP_BOUNDS_CHANGED_INTERVAL);			
	}

	public onMapZoomChanged() {
		
	}

	public onMapIdle() {
		this.overlayProjection = this.mapOverlay?.getProjection();
		
		if(this.showSearchPopUp.show)
		{
			setTimeout(() => {
				//this.displaySearchPopup();	
			}, 10);
		}
		this.mapIdle.emit(this.googleMapRef?.googleMap?.getBounds());
	}

	public onInfoWindowCloseClicked = ($event : any) => {
		this.infoWindowVisible = false;
	}

	public onMapClicked = (event : any) => {
		
	}
	
	public pixelOffsetToLatLng(offsetX : number, offsetY : number) 
	{
		const map = this.googleMapRef?.googleMap;
		let latlngPosition = null;
		if(!map)
		{
			return latlngPosition;
		}

		this.overlayProjection = this.mapOverlay?.getProjection();
		if(this.overlayProjection) 
		{
			latlngPosition = this.overlayProjection?.fromContainerPixelToLatLng(new google.maps.Point(offsetX, offsetY));				
		}
		else 
		{			
			const mapProjection = map.getProjection()!;
			const mapBounds = map.getBounds();
			if(mapProjection && mapBounds)
			{
				const topRight = mapProjection.fromLatLngToPoint(mapBounds.getNorthEast()!);
				const bottomLeft = mapProjection?.fromLatLngToPoint(mapBounds.getSouthWest()!);
				const scale = Math.pow(2, map.getZoom()!);
				if(bottomLeft && topRight)
				{
					const worldPoint = new google.maps.Point(offsetX / scale + bottomLeft.x!, offsetY / scale + topRight.y!);
					latlngPosition = map.getProjection()?.fromPointToLatLng(worldPoint);
				}				
			}			
		}

		return latlngPosition;
	}


	public fromLatLngToPoint(latLng : any, bounds? : google.maps.LatLngBounds) {		
		
		const map = this.googleMapRef?.googleMap;
		let screenPoint;
		this.overlayProjection = this.mapOverlay?.getProjection();
		if(this.overlayProjection) 
		{
			screenPoint = this.overlayProjection?.fromLatLngToContainerPixel(latLng);					
		}
		else 
		{
			if(!isUndefined(map) && !isNull(map))
			{
				const mapProjection = map?.getProjection();
				const mapBounds = map?.getBounds();
				const mapZoom = map.getZoom()!;
				if(mapProjection && mapBounds)
				{
					const mapDiv = this.googleMapRef?.googleMap?.getDiv();
					const center = mapProjection?.fromLatLngToPoint(this.googleMapRef!.googleMap!.getCenter()!);
					const topRight = mapProjection?.fromLatLngToPoint(mapBounds.getNorthEast()!);
					const bottomLeft = mapProjection?.fromLatLngToPoint(mapBounds.getSouthWest()!);
					const worldPoint = mapProjection?.fromLatLngToPoint(latLng);
					const scale = Math.pow(2, mapZoom);
					
					if(topRight && bottomLeft && worldPoint)
					{
						screenPoint = new google.maps.Point(
							(worldPoint?.x - bottomLeft?.x) * scale, 
							(worldPoint?.y - topRight?.y) * scale
						);						
					}				
				}			
			}
		}		

		return screenPoint;		
	}

} 
